var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import { forwardRef } from 'react';
import styled from '@emotion/styled';
import { theme } from '../../../globals/ThemeProvider';
var errorBoxShadow = '0 0 6px #f8b9b7';
var focusBoxShadow = 'inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6)';
var InputStyled = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: ", ";\n  padding: ", ";\n  border-radius: 0.29rem;\n  font-family: ", ";\n  font-size: 1rem;\n  display: block;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  color: #555;\n  outline: none;\n  background: ", ";\n  border: ", ";\n\n  &::placeholder {\n    color: #999;\n    font-size: 1.15rem;\n    opacity: 1;\n  }\n\n  &:focus {\n    background: #fff;\n    border-color: ", ";\n    box-shadow: ", ";\n  }\n"], ["\n  width: 100%;\n  height: ", ";\n  padding: ", ";\n  border-radius: 0.29rem;\n  font-family: ", ";\n  font-size: 1rem;\n  display: block;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  color: #555;\n  outline: none;\n  background: ", ";\n  border: ", ";\n\n  &::placeholder {\n    color: #999;\n    font-size: 1.15rem;\n    opacity: 1;\n  }\n\n  &:focus {\n    background: #fff;\n    border-color: ", ";\n    box-shadow: ", ";\n  }\n"])), function (_a) {
    var inputSize = _a.inputSize;
    return (inputSize === 'lg' ? '3.15rem' : '2rem');
}, function (_a) {
    var inputSize = _a.inputSize;
    return (inputSize === 'lg' ? '0 2.15rem 0 1.07rem' : '0 1rem');
}, (_a = theme === null || theme === void 0 ? void 0 : theme.fonts) === null || _a === void 0 ? void 0 : _a.default, function (_a) {
    var _b;
    var error = _a.error;
    return (error ? (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.backgroundDanger : '#fff');
}, function (_a) {
    var _b;
    var error = _a.error;
    return (error ? "1px solid ".concat((_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.borderDanger) : '1px solid #ccc');
}, function (_a) {
    var _b;
    var error = _a.error;
    return (error ? (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.borderDanger : '#66afe9');
}, function (_a) {
    var error = _a.error;
    return (error ? errorBoxShadow : focusBoxShadow);
});
export var Input = forwardRef(function (_a, ref) {
    var props = __rest(_a, []);
    return <InputStyled data-testid={"input-".concat(props.type)} ref={ref} {...props}/>;
});
Input.displayName = 'Input';
var templateObject_1;
